import React, {useContext} from "react";
import { AppContext } from "../context/Context";
import { Link } from "react-router-dom";
import { BASE_URL } from "../api/Api";
export default function CsrFooter()

 {
    const { siteSetting, loading } = useContext(AppContext);
  
    if (loading || !siteSetting) return null;
  return (
    <footer className="ucsr-footer">
      <div className="container">
        <div className="row gy-4">

          {/* LOGO + DESCRIPTION */}
          <div className="col-lg-4 col-md-6">
            <div className="ucsr-footer-logo">
              <img src={`${BASE_URL}/assets/images/${siteSetting.logo3}`} style={{ width: '25%', height: 'auto' }} alt="CSR Portal Logo" className="ucsr-footer-logo-img" />
              <div>
                <h6>CSR Portal</h6>
                <small>Maharashtra Government</small>
              </div>
            </div>

            <p className="ucsr-footer-desc">
              {siteSetting.address}
              <small><br />Office Hours: {siteSetting.visiting_hours}</small>
            </p>
          </div>

          {/* QUICK LINKS */}
          <div className="col-lg-2 col-md-6">
            <h5 className="ucsr-footer-heading">Quick Links</h5>
            <ul className="ucsr-footer-list">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact_us">Contact Us</Link></li>
            </ul>
          </div>

          {/* STAKEHOLDERS */}
          <div className="col-lg-3 col-md-6">
            <h5 className="ucsr-footer-heading">For Stakeholders</h5>
            <ul className="ucsr-footer-list">
              <li><a href="#">Corporates</a></li>
              <li><a href="#">NGOs</a></li>
              <li><a href="#">Government</a></li>
              <li><a href="#">Individuals</a></li>
            </ul>
          </div>

          {/* LEGAL */}
          <div className="col-lg-3 col-md-6">
            <h5 className="ucsr-footer-heading">Legal</h5>
            <ul className="ucsr-footer-list">
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Terms of Service</a></li>
              <li><a href="#">Disclaimer</a></li>
              {/* <li><Link to="/contact_us">Contact Us</Link></li> */}
            </ul>
          </div>

        </div>

        <div className="ucsr-footer-divider"></div>

        <div className="ucsr-footer-bottom">
          <p>© 2024 CSR Portal. All rights reserved.</p>

          <div className="ucsr-footer-bottom-links">
            <a href="#">Privacy</a>
            <a href="#">Terms</a>
            <a href="#">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
